export const keyboardShortcutsHelpLink = 'https://support.esgisoftware.com/hc/en-us/articles/209160286-Keyboard-Shortcuts';